import Modal from 'react-modal';
import { FcGoogle } from 'react-icons/fc';
import { RxCross1 } from 'react-icons/rx';
import { auth } from '../../config/firebase.config';
import { GoogleAuthProvider, signInWithPopup } from '@firebase/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

Modal.setAppElement('#react-modal-portal');

const LoginModal = ({ loginModalIsOpen, toggleLoginModal }) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      const googleProvider = new GoogleAuthProvider();
      await signInWithPopup(auth, googleProvider);
      toggleLoginModal();
      toast.success('Login Successfully');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <div className='relative'>
      <Modal
        isOpen={loginModalIsOpen}
        onRequestClose={toggleLoginModal}
        className='bg-gray-500 w-[70%] md:w-[35%] absolute top-[30%] left-[15%] md:left-[30%] rounded-lg py-3 px-5'
      >

        <div className='w-fit ml-auto'>
          <button className='bg-red-500 text-white p-2 font-bold text-lg rounded-full' onClick={toggleLoginModal}>
            <RxCross1 />
          </button>
        </div>
        <button
          onClick={handleClick}
          className='bg-white py-4 my-[15%] text-2xl md:text-3xl rounded-lg cursor-pointer w-full capitalize flex items-center justify-center gap-2'>
          <FcGoogle />
          <span className='text-base md:text-lg'>signin with google</span>
        </button>
      </Modal>
    </div>
  );
}

export default LoginModal
